import { z } from 'zod/v4';

/** The ids of the caller's own documents to take out of its archive — a bare array, as bulk-archive takes. */
export const BulkRestoreCompanyDocumentsBodySchema = z
  .array(z.string().min(1))
  .min(1);

/**
 * The ids this call restored. Ids of documents that are not the caller's own,
 * or that it has not archived, are skipped rather than failing the batch, so
 * this can be shorter than the request.
 */
export const BulkRestoreCompanyDocumentsResponseSchema = z.object({
  restoredDocumentIds: z.array(z.string()),
});

export type BulkRestoreCompanyDocumentsBody = z.infer<
  typeof BulkRestoreCompanyDocumentsBodySchema
>;
export type BulkRestoreCompanyDocumentsResponse = z.infer<
  typeof BulkRestoreCompanyDocumentsResponseSchema
>;
